// extracted by mini-css-extract-plugin
export default {"lineing":"home_lineing__Svyou","centerele":"home_centerele__uasfz"};